import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from '@main/app.component';

registerLocaleData(localeEn, 'en-US');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
